var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "van-cell-group",
        [
          _c("van-cell", { attrs: { title: "发票类型", value: _vm.type } }),
          _vm._v(" "),
          _c("van-field", {
            attrs: {
              name: "开票姓名",
              label: "开票姓名",
              placeholder: "开票姓名",
              rules: [{ required: true, message: "请输入开票姓名" }]
            },
            model: {
              value: _vm.userName,
              callback: function($$v) {
                _vm.userName = $$v
              },
              expression: "userName"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("van-cell", { attrs: { title: "发票内容", value: _vm.content } }),
      _vm._v(" "),
      _c("van-cell", { attrs: { title: "开票金额", value: _vm.money } }),
      _vm._v(" "),
      _c("van-field", {
        attrs: {
          name: "身份证号",
          label: "身份证号",
          placeholder: "身份证号",
          rules: [{ required: true, message: "请输入身份证号" }]
        },
        model: {
          value: _vm.ghdwsbh,
          callback: function($$v) {
            _vm.ghdwsbh = $$v
          },
          expression: "ghdwsbh"
        }
      }),
      _vm._v(" "),
      _c(
        "van-cell-group",
        [
          _c("van-field", {
            attrs: {
              required: "",
              clearable: "",
              label: "接收邮箱",
              placeholder: "请输入邮箱地址"
            },
            model: {
              value: _vm.email,
              callback: function($$v) {
                _vm.email = $$v
              },
              expression: "email"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-cell-group",
        [
          _c("van-field", {
            staticClass: "uploadBox",
            attrs: { name: "uploader", label: "身份证照" },
            scopedSlots: _vm._u([
              {
                key: "input",
                fn: function() {
                  return [
                    _c("van-uploader", {
                      staticClass: "imgList",
                      attrs: {
                        "after-read": _vm.idCardImgUpload,
                        "before-delete": _vm.deleteIdCardImg,
                        accept: "image/*",
                        "max-size": 2 * 1024 * 1024,
                        multiple: "",
                        "max-count": 2,
                        "upload-text": "最多可上传2张"
                      },
                      model: {
                        value: _vm.idNoPics,
                        callback: function($$v) {
                          _vm.idNoPics = $$v
                        },
                        expression: "idNoPics"
                      }
                    })
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-cell-group",
        [
          _c("van-field", {
            staticClass: "uploadBox",
            attrs: { name: "uploader", label: "房产证/租房合同" },
            scopedSlots: _vm._u([
              {
                key: "input",
                fn: function() {
                  return [
                    _c("van-uploader", {
                      staticClass: "imgList",
                      attrs: {
                        "after-read": _vm.propertyPicsUpload,
                        "before-delete": _vm.deletePropertyPics,
                        accept: "image/*",
                        "max-size": 2 * 1024 * 1024,
                        multiple: "",
                        "max-count": 3,
                        "upload-text": "最多可上传3张"
                      },
                      model: {
                        value: _vm.propertyPics,
                        callback: function($$v) {
                          _vm.propertyPics = $$v
                        },
                        expression: "propertyPics"
                      }
                    })
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "submitWrap" },
        [
          _c(
            "van-button",
            {
              staticClass: "submit",
              attrs: { type: "primary", block: "" },
              on: { click: _vm.handleSubmit }
            },
            [_vm._v("提交申请")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e786979e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e786979e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/invoicing/invoicing.vue
// module id = null
// module chunks = 